/* PERROWALL home (v2 maquette) — comportements : icônes, reveal, finder. Cart/recherche = Horizon. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var I = {
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>',
    shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>',
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M3 7h11v8H3z"/><path d="M14 10h4l3 3v2h-7z"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/></svg>',
    lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>'
  };

  function reveal() {
    var els = $$('.pw-store .reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  function toast(msg) {
    var el = $('#pw-toast');
    if (!el) { el = document.createElement('div'); el.id = 'pw-toast'; el.className = 'toast'; document.body.appendChild(el); }
    el.textContent = msg; el.classList.add('show');
    clearTimeout(toast._t); toast._t = setTimeout(function () { el.classList.remove('show'); }, 2200);
  }

  var RECO = {
    cercle: { name: 'SafeZone, clôture sans-fil', desc: 'Un périmètre sans fil, posé en une après-midi, sans tranchée. Idéal jardin.', price: 'dès 189,90 €', href: '/products/safezone-anti-fugue-sans-fil-v2' },
    trace:  { name: 'SafeSpace, clôture filaire', desc: 'Une frontière invisible sur mesure pour les grands terrains.', price: 'dès 169,90 €', href: '/products/cloture-anti-fugue-invisible' },
    geo:    { name: 'GeoGuard, anti-fugue GPS', desc: 'La sécurité sans limite de périmètre, suivi en temps réel.', price: 'dès 189,90 €', href: '/products/geoguard-cloture-anti-fugue-gps' },
    secure: { name: 'SecureTouch, collier de dressage', desc: 'Le rappel fiable à distance, du plus doux au dernier recours.', price: 'dès 44,90 €', href: '/products/securetouch-collier-de-dressage-longue-portee' }
  };
  function recoFor(a) {
    var fence = a.terrain === 'clos' ? 'cercle' : a.terrain === 'ouvert' ? 'trace' : 'geo';
    if (a.besoin === 'rappel') return ['secure'];
    if (a.besoin === 'fugue') return [fence];
    return [fence, 'secure'];
  }
  function finder() {
    var root = $('#finderSteps'); if (!root) return;
    var steps = $$('.finder__step', root);
    var bars = $$('.finder__bar i', root);
    var result = $('#finderResult', root), back = $('#finderBack', root);
    var cur = 0; var answers = {};
    function show() {
      steps.forEach(function (s, i) { s.style.display = i === cur ? 'block' : 'none'; });
      bars.forEach(function (b, i) { b.classList.toggle('on', i <= cur); });
      back.style.visibility = cur > 0 ? 'visible' : 'hidden';
    }
    function render() {
      var keys = recoFor(answers);
      result.innerHTML = '<p class="eyebrow" style="color:var(--clay)">Notre recommandation</p>'
        + '<h3 class="h3" style="color:var(--paper);margin-bottom:16px">Voici ce qu’il te faut.</h3>'
        + keys.map(function (k, idx) {
          var p = RECO[k];
          var img = (window.PW_FINDER_IMG && window.PW_FINDER_IMG[k]) || '';
          var media = img
            ? '<img src="' + img + '" alt="' + p.name + '" width="96" height="96" loading="lazy">'
            : '<div class="ph-photo">' + p.name.split(',')[0] + '</div>';
          return '<a class="fres-card ' + (idx ? 'reco-2' : '') + '" href="' + p.href + '">'
            + media
            + '<div><h4>' + p.name + '</h4><p>' + p.desc + '</p><div class="fres-price">' + p.price + '</div></div></a>';
        }).join('')
        + '<button class="finder__back" id="finderRestart" style="margin-top:14px">↺ Recommencer</button>';
      $('#finderRestart', result).addEventListener('click', function () {
        cur = 0; Object.keys(answers).forEach(function (k) { delete answers[k]; });
        root.classList.remove('fading'); root.classList.remove('done'); result.classList.remove('show'); show();
      });
      // Le questionnaire disparaît en fondu, puis la réponse apparaît à sa place.
      root.classList.add('fading');
      setTimeout(function () { root.classList.add('done'); result.classList.add('show'); }, 300);
    }
    $$('.finder__opt', root).forEach(function (opt) {
      opt.addEventListener('click', function () {
        answers[steps[cur].dataset.key] = opt.dataset.val;
        if (cur < steps.length - 1) { cur++; show(); } else render();
      });
    });
    back.addEventListener('click', function () { if (cur > 0) { cur--; show(); } });
    show();
  }

  function emailForms() {
    $$('.pw-store form[data-pw-mail]').forEach(function (f) {
      var input = f.querySelector('input[type="email"]');
      var btn = f.querySelector('button');
      var fine = f.parentNode && f.parentNode.querySelector('.cadeau__fine');
      var consentText = fine ? fine.textContent.replace(/\s+/g, ' ').trim() : null;
      f.addEventListener('submit', function (e) {
        e.preventDefault();
        var email = (input && input.value || '').trim();
        if (!email) { return; }
        if (!window.PWLead) { toast('Oups, réessaie dans un instant.'); return; }
        if (btn) { btn.disabled = true; }
        window.PWLead.submit(email, {
          source: f.getAttribute('data-source') || 'home-guide-band',
          consentText: consentText
        }).then(function (ok) {
          if (btn) { btn.disabled = false; }
          if (!ok) { toast('Oups, réessaie dans un instant.'); return; }
          var url = window.PWLead.cfg && window.PWLead.cfg.guide_url;
          var wrap = (f.closest && f.closest('.cadeau__form')) || f.parentNode;
          if (wrap && url) {
            wrap.innerHTML =
              '<p style="font-weight:600;margin:0 0 12px">Merci&nbsp;! Ton guide est prêt.</p>' +
              '<a class="btn" href="' + url + '" target="_blank" rel="noopener">Télécharger le guide (PDF) ' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v11"/><path d="M8 11l4 4 4-4"/><path d="M5 19h14"/></svg></a>' +
              '<p class="cadeau__fine" style="margin-top:12px">Une copie part aussi sur ton e-mail.</p>';
          } else {
            f.reset(); toast('Merci, ton guide arrive par e-mail.');
          }
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('.pw-store [data-ic]').forEach(function (el) { el.innerHTML = I[el.dataset.ic] || ''; });
    reveal(); finder(); emailForms();
  });
})();
